import { FormControl } from '@angular/forms';

// custom validator to check that value is object and has id field
export function ObjectIdValidator(control: FormControl) {
  if (control.value && control.value.id) {
    return null
  }
  return { objectId: true };
}
